import { render, staticRenderFns } from "./ServiceProvisionRules.vue?vue&type=template&id=9225c338&scoped=true&"
import script from "./ServiceProvisionRules.vue?vue&type=script&lang=js&"
export * from "./ServiceProvisionRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9225c338",
  null
  
)

export default component.exports